import ServerDataGrid from "../../../components/datagrid/ServerDataGrid";
import { columns } from "./damageColumns";

export function DamageTablePage() {
  return (
    <ServerDataGrid
      columns={columns}
      getRowId={(row) => row.damage.id}
      apiEndpoint="/datagrid/damage"
      tableName="damage"
      enableCreate={false}
      enableSearch={true}
      height={"calc(100vh - 52.6px)"}
      initialStateOverride={{
        sorting: { sortModel: [{ field: "damage.received", sort: "desc" }] },
      }}
    />
  );
}
